import { useEffect } from 'react';
import { initialize as initializeAnalytics } from '@fff-web/fff-analytics';
import { getLogoImage, useUserContext } from '@fff-web/fff-utilities';
import { LegalFooterContainer } from './components/LegalFooter';
import { LinkFooter } from './components/LinkFooter';
import { SocialMediaFooter } from './components/SocialMediaFooter';
import useFooterContent from './hooks/useFooterContent';
import useUserWay from './hooks/useUserWay';
import { loadPactSafe } from './utils/loadPactSafe';
import './GlobalFooterDefault.scss';
import { ChatWidget, type ChatWidgetProps } from './components/ChatWidget';

interface GlobalFooterDefaultProps {
  minimalFooter?: boolean;
  isUseAnalytic?: boolean;
  pathname?: string;
  chatbotConfig?: Partial<ChatWidgetProps>;
}

const GlobalFooterDefault = ({
  minimalFooter = false,
  isUseAnalytic = true,
  chatbotConfig,
}: GlobalFooterDefaultProps) => {
  const { footerContent: data } = useFooterContent();
  const {
    userInfo: { loggedIn },
  } = useUserContext();

  useUserWay();

  useEffect(() => {
    if (isUseAnalytic) initializeAnalytics();
    loadPactSafe();
  }, [isUseAnalytic]);

  if (!data) {
    return null;
  }

  // TODO: ChatbotProvider should ideally be placed at the app root level to maintain a single instance.
  // This will be addressed when consolidating into a single project.
  return (
    <footer data-testid="global-footer" className={'fff-shared-footer-container'}>
      {chatbotConfig?.agentId && (
        <ChatWidget agentId={chatbotConfig.agentId} hideWidget={chatbotConfig.hideWidget} />
      )}

      {!minimalFooter && (
        <div className={'fff-shared-footer-container-top'}>
          <div className="fff-logo-container">
            <img alt="logo" src={getLogoImage()} className="fff-logo" />
          </div>
          <div className="fff-shared-footer-links-container">
            <LinkFooter
              categories={loggedIn ? data?.mainFooter?.loginState : data?.mainFooter?.logoutState}
            />
            <div className="fff-shared-footer-social-media-container">
              <SocialMediaFooter icons={data?.socialMedias.icons} />
            </div>
          </div>
        </div>
      )}
      <LegalFooterContainer legals={data?.legal} isLoggedIn={loggedIn} />
    </footer>
  );
};

export { GlobalFooterDefault };
export type { GlobalFooterDefaultProps };
